import React from 'react';
import InstanceTarget from '../../../types/instance/InstanceTarget';

interface DashboardGroupHeaderProps {
    groupName: string;
    groupInstances: InstanceTarget[];
    onGroupSelect: (groupName: string, instances: InstanceTarget[]) => void;
}

const DashboardGroupHeader: React.FC<DashboardGroupHeaderProps> = ({
    groupName,
    groupInstances,
    onGroupSelect
}) => {
    return (
        <h5
            className="group-header clickable"
            onClick={() => onGroupSelect(groupName, groupInstances)}
            title={`View details for group: ${groupName}`}
        >
            {groupName}
            <span className="group-count-badge">{groupInstances.length}</span>
        </h5>
    );
};

export default DashboardGroupHeader; 